import React, { useEffect } from 'react';
import { useAppStore } from '@/lib/store';

export default function FallbackNotification() {
  const { fallbackNotification, clearFallbackNotification } = useAppStore();

  useEffect(() => {
    if (fallbackNotification) {
      const t = setTimeout(clearFallbackNotification, 5000);
      return () => clearTimeout(t);
    }
  }, [fallbackNotification]);

  if (!fallbackNotification) return null;

  return (
    <div className="absolute top-4 left-1/2 -translate-x-1/2 z-50 flex items-center gap-3 bg-[#784A15] border border-[#ED8B38] text-[#ED8B38] text-[13px] px-4 py-2.5 rounded-lg shadow-xl animate-fade-in">
      <svg className="w-4 h-4 flex-shrink-0" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <circle cx="12" cy="12" r="10" />
        <line x1="12" y1="8" x2="12" y2="12" />
        <line x1="12" y1="16" x2="12.01" y2="16" />
      </svg>
      <span>
        Switched to <strong className="text-white">{fallbackNotification.provider || 'fallback'}</strong> — primary key failed
      </span>
      <button onClick={clearFallbackNotification} className="ml-2 text-[#b3b4b7] hover:text-white">
        <svg className="w-3.5 h-3.5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" /></svg>
      </button>
    </div>
  );
}
